// images
import blogImg2 from "../images/blog/white-papper.jpg";


const blogs = [
   
  {
  id: "2",
  title: "World Economic Forum's Global Cybersecurity Outlook 2025",
  slug: "https://reports.weforum.org/docs/WEF_Global_Cybersecurity_Outlook_2025.pdf",
  screens: blogImg2, 
  description: "This report identifies AI-enabled cyber-fraud and the commoditization of ransomware as top organizational risks for 2025. It emphasizes the need for innovative strategies to keep pace with the evolving tactics of cybercriminals.",
  author: "Augmentity.net",
  authorTitle: "Cybersecurity Insights",
  create_at: "September 15, 2025",
  comment: "0",
  thumb: "Cybersecurity",
  blClass: "format-standard-image",
}

    
];


export default blogs;